import { render, staticRenderFns } from "./official.vue?vue&type=template&id=59c3fc53&scoped=true"
var script = {}
import style0 from "./official.vue?vue&type=style&index=0&id=59c3fc53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c3fc53",
  null
  
)

export default component.exports